import {Component, Vue} from 'vue-property-decorator';
import {gsap, Power3} from '@/utils/gsap';

@Component({})
export default class ScrollTo extends Vue {
	scrollToSection(section: Element, autokill: boolean = true): void {

		if (typeof window === 'undefined') {
			return;
		}

		gsap.to(window, 1, {
			scrollTo: {
				y: section,
				autoKill: autokill
			},
			ease: Power3.easeInOut,
			delay: 0
		});
	}
}
